import React, { FC, ReactNode, useState } from 'react'
import styled, { css } from 'styled-components'

import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import arrowIco from '../../../assets/arrow.svg'
import * as Table from './Table.styled'

const MobileRowStyled = styled(Table.Tr)`
  td {
    &:nth-last-child(1) {
      border-left: none;
    }
  }
`

const Ico = styled.button<{ $isOpen: boolean }>`
  border: none;
  width: 30px;
  height: 30px;
  background: url(${arrowIco}) center center no-repeat;
  transition: 0.3s;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`

interface MobileTableRowProps {
  rowLabel: string | ReactNode
  children: ReactNode
  testId?: string
}

export const MobileRow: FC<MobileTableRowProps> = ({ rowLabel, children, testId }) => {
  const [openDetail, setOpenDetail] = useState(false)

  const usedTestId = testId ?? 'mobile-row'

  return (
    <React.Fragment>
      <MobileRowStyled data-testid={createTestId(usedTestId, 'row')}>
        <Table.Td data-testid={createTestId(usedTestId, 'label')}>{rowLabel}</Table.Td>
        <Table.Td align={'right'} data-testid={createTestId(usedTestId, 'toggle')}>
          <Ico
            $isOpen={openDetail}
            onClick={() => setOpenDetail((c) => !c)}
            data-testid={createTestId(usedTestId, 'toggle-button')}
          />
        </Table.Td>
      </MobileRowStyled>
      {openDetail && children}
    </React.Fragment>
  )
}
